import viacep from '../viacep';

class ViacepApi {

    constructor() {
        this.endpoint = '/ws'
    }

    get = zipCode => {
        return viacep.get(`${this.endpoint}/${zipCode}/json/`, {data: ''});
    }

}

const instance = new ViacepApi();

export default instance;